<template>
  <!-- 异常原文合并弹窗 -->
  <div class="srcMerge">
    <el-dialog
      width="75%"
      title="取消原译文合并"
      :visible="visible"
      :close-on-click-modal="false"
      @close="closeDialog"
      center
    >
      <div class="m-b-5 f-w-600">确定取消合并如下句子原译文？</div>
      <el-table
        class="f-s-14 m-b-15"
        style="width: 100%"
        max-height="150"
        border
        :data="sentData"
        :row-class-name="getGrey"
      >
        <el-table-column
          prop="id"
          label="句子ID"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column prop="srcText" label="原文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.srcText" readonly />
          </template>
        </el-table-column>
        <el-table-column prop="mtText" label="机翻译文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.mtText" readonly />
          </template>
        </el-table-column>
        <el-table-column prop="peTextShow" label="译文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.peTextShow" readonly />
          </template>
        </el-table-column>
      </el-table>
      <div class="m-b-5 f-w-600">取消合并后效果预览</div>
      <el-table
        class="f-s-14 m-b-15"
        style="width: 100%"
        max-height="150"
        border
        :data="previewData"
        :row-class-name="getGrey"
      >
        <el-table-column
          prop="sentId"
          label="句子ID"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column prop="srcText" label="原文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.srcText" readonly />
          </template>
        </el-table-column>
        <el-table-column prop="mtText" label="机翻译文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.mtText" readonly />
          </template>
        </el-table-column>
        <el-table-column prop="peText" label="译文" align="center">
          <template slot-scope="scope">
            <rich-text :jsonText="scope.row.peText" readonly />
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mergeCancel">确定取消合并</el-button>
        <el-button @click="closeDialog">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mergeSentList, cancelMergeSent } from '@/api/dot/qc';
import { statistics } from '@/api/dot/flow';
import RichText, { jsonTextToText } from '@/components/rich-text';

export default {
  name: 'CancelMergeDialog',
  props: [
    'visible',
    'staParams', // 上报公共参数
    'row',
    'qcTaskId',
  ],
  components: {
    RichText,
  },
  data() {
    return {
      sentData: [],
      previewData: [],
    };
  },
  watch: {
    visible(val) {
      if (val) {
        // 弹窗每次出现都更新句子
        this.sentData = [];
        this.sentData.push(this.row);
        this.getSentList();
      } else {
        this.sentData = [];
        this.previewData = [];
      }
    },
  },
  methods: {
    // 获取合并前的句子列表
    getSentList() {
      mergeSentList({
        sentId: this.row.id,
      }).then((res) => {
        this.previewData = res?.data?.data;
      });
    },

    // 取消句子合并
    mergeCancel() {
      cancelMergeSent({
        qcTaskId: this.qcTaskId,
        sentId: this.row.id,
      }).then((res) => {
        this.sentData = [];
        this.previewData = [];
        this.$message.success('操作成功');
        this.closeDialog();
        this.$emit('sent-merge');
      });
      statistics(
        Object.assign(
          {
            event_name: '取消合并',
            event_type: 'click',
            class_name: 'mergeSent',
            qcTermList: '/dotadmin/dotadmin/merge/cancelMergeSent',
          },
          this.staParams,
        ),
      );
    },

    // 关闭弹窗回调
    closeDialog() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
